module.exports = __webpack_public_path__ + "img/icon-result.85bb4610.svg";